// extracted by mini-css-extract-plugin
export var divider = "_h5-7";
export var itemsToggle = "_h5-8";
export var mergeModal = "_h5-1";
export var optionCard = "_h5-4";
export var radioGroup = "_h5-6";
export var radioOption = "_h5-0";
export var selected = "_h5-5";
export var shipmentOptions = "_h5-2";
export var tableOptions = "_h5-3";